import React, { useCallback, useContext, useEffect, useState } from "react";
import { CartesianGrid, Label, Legend, ResponsiveContainer, Scatter, ScatterChart, Text, Tooltip, XAxis, YAxis, ZAxis } from "recharts";
import { useCurrentPng } from "recharts-to-png";
import { saveAs } from "file-saver";
import axios from "axios";
import Contexto from "../comun/Contexto";

const ResRtasTiempo = ({idSismo})=> {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    const [respuestasTiempo, setRespuestasTiempo] = useState();

    /* Efectos */
    useEffect(() => {
        console.log("efecto constructor "+ idSismo);
       
        const traerDatos = async (url, callback) => {
            const res = await axios(url);
            callback(res.data)
        }
    
        traerDatos(urlBaseRest+"grafico_reportes_tiempo_minutos/"+idSismo, setRespuestasTiempo);
    }, []);    

    const [getPngGRT, { ref: refGraficoGRT}] = useCurrentPng();

    const descargarGRT = useCallback(async () => {
        const png = await getPngGRT();
        if (png) {
            saveAs(png, 'respuestas_tiempo.png');
        }
    } , [getPngGRT]);   

    const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
        return <text x={x + width / 2} y={y} fill="#666" textAnchor="middle" dy={-6}>{`value: ${value}`}</text>;
    };

    const etiquetaY = ({ kapi, metric, viewBox }) => {
        return (
            <Text              
            dx={30}  
            dy={110 + (viewBox.height/2)}
            angle={-90} >
                No. de respuestas
            </Text>
        );
    };

    return (
        <div className="ResultadosContenedorH">
            <div style={{height:"100%", display:"flex", flexDirection:"column", /*backgroundColor:"#F60"*/}}>
                <ResponsiveContainer width={800} height="100%">            
                <ScatterChart
                ref={refGraficoGRT}                        
                margin={{ top: 20, right: 20, bottom: 10, left: 10 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" dataKey="U_MED" name="tiempo" >
                        <Label value="Tiempo (minutos)" offset={0} position="insideBottom" />
                    </XAxis>
                    <YAxis type="number" dataKey="NUM_REPORTES_ACUMULADOS" name="respuestas" label={etiquetaY} />
                    <Tooltip cursor={{ strokeDasharray: '30 30' }} />                   
                    <Legend verticalAlign="top" height={36}/>
                    <Scatter name="Respuestas vs Tiempo" data={respuestasTiempo} fill="#8884d8" />      
                </ScatterChart>
                </ResponsiveContainer>                
            </div>
            <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                <div className="ResultadosRecuadro">
                    En el gráfico se observa la cantidad de formularios diligenciados por los usuarios desde el momento en que ocurrió el sismo hasta algunas horas después del mismo. El número de formularios diligenciados en minutos, horas y días después de un evento refleja el interés de los ciudadanos para proporcionar y recibir información sobre el sismo.                
                </div>
                <button onClick={descargarGRT} className="GraficosBoton">Exportar imagen</button>
            </div>
        </div>
    )
}

export default ResRtasTiempo;